import React from 'react';
import PropTypes from 'prop-types';
import DesignDetailsActionCreators from 'apps/designdetails/actions/DesignDetailsActionCreators';

export default class LikeButton extends React.Component {
    constructor(props) {
        super(props);
        this.toggleLike = this.toggleLike.bind(this);
    }

    getClassName() {
        let className = 'like-button icon icon--like-1 ';
        if (this.props.design.likedByUser) {
            className += 'like-button--active';
        }
        return className;
    }

    toggleLike() {
        if (this.props.design.likedByUser) {
            this.unlikeDesign();
        } else {
            this.likeDesign();
        }
    }

    unlikeDesign() {
        this.context.executeAction(
            DesignDetailsActionCreators.unlikeDesign, {
                designId: this.props.design.designId,
                designLikeUrl: this.props.design.links.likeDesignUrl,
                csrfToken: this.props.csrfToken,
            },
        );
    }

    likeDesign() {
        this.context.executeAction(
            DesignDetailsActionCreators.likeDesign, {
                designId: this.props.design.designId,
                designLikeUrl: this.props.design.links.likeDesignUrl,
                csrfToken: this.props.csrfToken,
            },
        );
    }

    render() {
        return (
            <button
                className="icon-button icon-button--on-white icon-button--offset-right"
                onClick={this.toggleLike}
            >
                <span className={this.getClassName()} />
            </button>
        );
    }
}

LikeButton.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    csrfToken: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};

LikeButton.contextTypes = {
    executeAction: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/LikeButton.jsx